<template>
  <v-date-input
    v-model="innerValue"
    prepend-icon=""
    :display-format="formatDate"
    v-bind="$attrs"
    autocomplete="off"
  ></v-date-input>
</template>
<script>
export default {
  name: "v-date-field",

  props: {
    modelValue: {
      type: [String, Date],
    },
  },

  methods: {
    formatDate(date) {
      if (!date) {
        return "";
      }

      return new Date(date).toLocaleDateString("es-MX", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
  },

  watch: {
    value(newValue) {
      if (!newValue) {
        this.$emit("update:modelValue", null);
        return;
      }

      this.$emit("update:modelValue", this.$date(newValue));
    },
  },

  computed: {
    innerValue: {
      get() {
        if (!this.modelValue) {
          return null;
        }
        return this.$date(this.modelValue);
      },
      set(newValue) {
        if (!newValue) {
          this.$emit("update:modelValue", null);
          return;
        }

        this.$emit("update:modelValue", this.$date(newValue));
      },
    },
  },
  emits: ["update:modelValue"],
};
</script>
